export default __webpack_public_path__ + "static/media/small.89c20f00.jpg";